export default __webpack_public_path__ + "static/media/annex5.a361cb78.png";